var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',[_vm._v(" "+_vm._s(_vm.item.street)+" ")]),_c('td',[_vm._v(" "+_vm._s(_vm.item.zip)+" ")]),_c('td',[_vm._v(" "+_vm._s(_vm.item.city)+" ")]),_c('td',[_vm._v(" "+_vm._s(_vm.item.description ? _vm.item.description : '-')+" ")]),_c('td',[_vm._v(" "+_vm._s(_vm.item.office ? _vm.item.office.name : '-')+" ")]),_c('td',[(
        _vm.$userCheckAccess({
          abilities: 'edit_client_addresses',
        })
      )?_c('div',{staticClass:"buttons"},[_c('WorkClientAddressModal',{attrs:{"create":false,"id":_vm.item.id}}),_c('DeleteModal',{attrs:{"item":_vm.item,"text":_vm.localStorage.translations.pages['setting-client']['address-dialog-delete'][
            'udalit-adres'
          ] +
          ' ' +
          _vm.item.street +
          ' ' +
          _vm.item.zip +
          ' ' +
          _vm.item.city}})],1):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }